import {
  Autocomplete,
  ButtonPrimary,
  ButtonSecondary,
  IconDownload,
  Popup,
  SidePanel,
  SidePanelType,
  ToggleInput,
} from '@ui/src';
import TopUpPanel from '../../top-up-panel';
import { CustomerAccountsPanelsTypes } from '../types';
import DownloadStatemenetPanel from '../../../../components/common/accounts/download-statement-panel';

import cn from '../styles.module.css';

const CustomerAccountsPanels = ({
  topUpPanelIsOpen,
  setTopUpPanelIsOpen,
  selectedTopUpId,
  setSelectedTopUpId,
  setSelectedAccount,
  baseInformation,
  setPopupVisible,
  setSelectedPrimaryAccount,
  setVisibleToClient,
  onCreateAccount,
  createAccountInProgress,
  popupVisible,
  primariesAccounts,
  selectedPrimaryAccount,
  visibleToClient,
  statementPanelVisible,
  onCloseStatementPanel,
  statementError,
  isLoading,
  isFetching,
  selectedCurrency,
  selectedDateType,
  selectedFormat,
  selectedDateRange,
  onDownloadStatement,
  currenciesList,
  setSelectedCurrency,
  setSelectedDateType,
  setSelectedDateRange,
  setSelectedFormat,
  selectedAccount,
}: CustomerAccountsPanelsTypes) => (
  <>
    <TopUpPanel
      topUpPanelIsOpen={topUpPanelIsOpen}
      setTopUpPanelIsOpen={setTopUpPanelIsOpen}
      selectedTopUpId={selectedTopUpId}
      setSelectedTopUpId={setSelectedTopUpId}
      setSelectedAccount={setSelectedAccount}
      selectedAccount={selectedAccount}
      userAccounts={baseInformation?.accounts?.map((item) => ({
        accountId: item.id,
        account: { fullNumber: item.fullNumber },
        description: item.description,
      }))}
    />
    <Popup
      title="You want to open a new account?"
      description="If required, you can select primary account"
      onCancelClick={() => {
        setPopupVisible(false);
        setSelectedPrimaryAccount('');
        setVisibleToClient(true);
      }}
      onOkClick={() => onCreateAccount()}
      cancelButtonText="Cancel"
      okButtonText={createAccountInProgress ? 'Loading...' : 'Open account'}
      okButtonDisabled={createAccountInProgress}
      isVisible={popupVisible}
    >
      <>
        <div className={cn.primaryAccountWrapper}>
          <Autocomplete
            name="primary-account"
            title="Primary account"
            placeholder="Select primary account (optional)"
            list={primariesAccounts || []}
            value={selectedPrimaryAccount}
            onChange={(e) =>
              setSelectedPrimaryAccount(e.target.value as string)
            }
            withClearButton
          />
        </div>
        <ToggleInput
          checked={visibleToClient}
          name="visibleToClient"
          onChange={(e) => setVisibleToClient(e.target.checked)}
          title="Account is visible to the client"
        />
      </>
    </Popup>
    <SidePanel
      title="Download account statement"
      isOpen={statementPanelVisible}
      onClose={onCloseStatementPanel}
      type={SidePanelType.AML}
      errorSidepanel={statementError}
      sidepanelExpandedKey="customers-accounts-statements"
      footer={
        <div className={cn.statementPanelControls}>
          <ButtonPrimary
            text={isLoading || isFetching ? 'Loading...' : 'Download'}
            icon={<IconDownload />}
            disabled={
              !selectedCurrency ||
              !selectedDateType ||
              !selectedFormat ||
              isLoading ||
              isFetching ||
              (selectedDateType === 'custom' && !selectedDateRange.length)
            }
            onClick={onDownloadStatement}
            bold
          />
          <ButtonSecondary
            className="button-white"
            text="Close"
            onClick={onCloseStatementPanel}
            bold
          />
        </div>
      }
      closeOnClickOutside
    >
      <DownloadStatemenetPanel
        selectedCurrency={selectedCurrency}
        currenciesList={currenciesList}
        setSelectedCurrency={setSelectedCurrency}
        selectedDateType={selectedDateType}
        setSelectedDateType={setSelectedDateType}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
        selectedFormat={selectedFormat}
        setSelectedFormat={setSelectedFormat}
        selectedAccount={selectedAccount}
      />
    </SidePanel>
  </>
);

export default CustomerAccountsPanels;
